import React from 'react';
import { RouteComponentProps } from 'react-router';

import queryString from 'query-string';

import { validateModerationTestToken } from '../../api';
import { TestChat } from '../TestChat/TestChat';
import { Page } from '../Typo/Typo';

import './ModerationTestPage.scss';

interface RouteProps {
    skillId: string;
}

type CommonProps = RouteComponentProps<RouteProps>;

interface State {
    stage: 'pending' | 'failure' | 'success';
}

export default class ModerationTestPage extends React.Component<CommonProps, State> {
    constructor(props: CommonProps) {
        super(props);

        this.state = { stage: 'pending' };
    }

    public componentDidMount() {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return this.setState({ stage: 'failure' });
        }

        validateModerationTestToken(this.props.match.params.skillId, parsed.token)
            .then(() => {
                this.setState({ stage: 'success' });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ stage: 'failure' });
            });
    }

    public render() {
        const { stage } = this.state;
        const { skillId } = this.props.match.params;

        const content =
            stage === 'success' ? (
                <TestChat skillId={skillId} isDraft />
            ) : stage === 'pending' ? (
                <div>Загрузка.</div>
            ) : (
                /* stage === 'failure' ? */ <div>Ссылка устарела.</div>
            );

        return (
            <Page>
                <Page.Content>
                    <Page.Page>{content}</Page.Page>
                </Page.Content>
            </Page>
        );
    }
}
